const notFoundPage: Record<string, Record<string, string> | string> = {
    notExist: 'Такой страницы не существует',
    goTo: 'Перейдите на ',
    main: 'Главную ',
    orReturn: 'или вернитесь ',
    back: 'Назад',
};

export default notFoundPage;
